import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { ChevronDown, X, Menu } from 'lucide-react';

const Navbar = () => {

  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const [selectedCountry, setSelectedCountry] = useState(
    window.location.hostname.includes("pravisht.com") &&
    !window.location.hostname.includes("co.uk")
      ? "India"
      : "United Kingdom"
  );

  return (
    <nav className="navbar fixed-navbar">
      
      <div className="navbar-logo" onClick={() => navigate('/')}>
        <img src="/pravisht-logo.svg" alt="Logo"/>
      </div>

      {/* Hamburger button */}
      <button
        className="mobile-menu-btn"
        onClick={() => setMenuOpen(true)}
        aria-label="Open menu"
      >
        <Menu size={30} />
      </button>

      {/* Desktop links */}
      <ul className="navbar-links">
        <li><a onClick={() => navigate('/About-us')} className="underline-hover">About Us</a></li>

        <li className="dropdown">
          <a href="#" className="underline-hover">
            Our Services <ChevronDown size={16} className="dropdown-icon" />
          </a>

          <ol className="dropdown-menu">
            <li><a href="/technology-developmen-services">Technology Development Services</a></li>
            <li><a href="/data-analytics-services">Data & Analytics Services</a></li>
            <li><a href="/next-genTesting-services">Next Gen Testing Services</a></li>
            <li><a href="/aiml-services">AI/ML Services</a></li>
            <li><a href="/mobile-app-devlopment-services">Enterprise Mobile App Development</a></li>
            <li><a href="/sales-force-competencies-services">Salesforce Competencies</a></li>
            <li><a href="/power-platform-services">Microsoft Power Platform Services</a></li>
          </ol>
        </li>

        <li><a onClick={() => navigate('/Our-Team')}>Our Team</a></li>
        {/* <li><a onClick={() => navigate('/Career')}>Career</a></li> */}
        <li><a onClick={() => navigate('/Blog')}>Blog</a></li>
      </ul>

      <select
        className="country-dropdown"
        value={selectedCountry}
        onChange={(e) => {
          const value = e.target.value;
          setSelectedCountry(value);

          if (value === "India") {
            window.location.href = "https://www.pravisht.com/";
          }
        }}
      >
        <option value="India">India</option>
        <option value="United Kingdom">United Kingdom</option>
      </select>

      <div
        className="navbar-getintouch-btn"
        onClick={() => navigate('/Contact-us')}
      >
        Get in Touch →
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>

        <div className="mobile-menu-header">
          <img src="/pravisht-logo.svg" alt="Logo" />

          <button
            className="close-menu-btn"
            onClick={() => setMenuOpen(false)}
          >
            <X size={24} />
          </button>
        </div>

        <ul className="mobile-menu-links">
          <li>
            <a onClick={() => {
              navigate('/AboutUs');
              setMenuOpen(false);
            }}>
              About Us
            </a>
          </li>

          <li>
            <details>
              <summary>
                Our Services <ChevronDown size={16} />
              </summary>

              <ul>
                <li><a href="/technology-developmen-services">Technology Development Services</a></li>
                <li><a href="/data-analytics-services">Data & Analytics Services</a></li>
                <li><a href="/next-genTesting-services">Next Gen Testing Services</a></li>
                <li><a href="/aiml-services">AI/ML Services</a></li>
                <li><a href="/mobile-app-devlopment-services">Enterprise Mobile App Development</a></li>
                <li><a href="/sales-force-competencies-services">Salesforce Competencies</a></li>
                <li><a href="/power-platform-services">Microsoft Power Platform Services</a></li>
              </ul>
            </details>
          </li>

          <li><a onClick={() => navigate('/Our-Team')}>Our Team</a></li>

          {/* <li>
            <a onClick={() => {
              navigate('/CareersSection');
              setMenuOpen(false);
            }}>
              Career
            </a>
          </li> */}

          <li>
            <a onClick={() => {
              navigate('/all-blogs');
              setMenuOpen(false);
            }}>
              Blog
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;